/* eslint-disable camelcase */
/* Shared lifecycle expand used by map popups and sidebar cards */

export function locationDeploymentDetailsHtml (location, options = {}) {
  const variant = options.variant || 'card'
  const {
    deployment_stage_label,
    installed_at,
    energized_at,
    activated_at,
    activation_sources
  } = location || {}

  if (!deployment_stage_label) {
    return ''
  }

  const sources = Array.isArray(activation_sources) && activation_sources.length > 0
    ? `<div class="text-xs text-gray-500">Sources: ${activation_sources.join(', ')}</div>`
    : ''

  const wrapperClass = variant === 'popup'
    ? 'deployment-lifecycle deployment-lifecycle--popup mt-2 text-xs border-t border-gray-100 pt-2'
    : 'deployment-lifecycle'

  return `
    <details class="${wrapperClass}">
      <summary class="deployment-lifecycle-toggle">
        <span class="deployment-lifecycle-label">
          <span class="font-semibold">Lifecycle</span>
          <span class="tag">${deployment_stage_label}</span>
        </span>
        <span class="deployment-lifecycle-action"></span>
      </summary>
      <div class="deployment-lifecycle-body">
        <div>Installed: ${installed_at || '—'}</div>
        <div>Energized: ${energized_at || '—'}</div>
        <div>Activated: ${activated_at || '—'}</div>
        ${sources}
      </div>
    </details>
  `
}
